import React, { lazy, Suspense, Fragment } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const LoginOrSignup = lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
//PinterestTemplatesMarketingPage
const PinterestTemplatesMarketingPage = lazy(() =>
  import(
    /* webpackChunkName: "PinterestTemplatesMarketingPage" */ "../components/PinterestTemplatesMarketingPage/PinterestTemplatesMarketingPage"
  )
);
const Templates = lazy(() =>
  import(
    /* webpackChunkName: "Templates" */ "../components/Templates/Templates"
  )
);

import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  heading: {
    paddingTop: theme.spacing(2),
  },
  subTitle: {
    padding: "0px 30px 0px 30px",
    textAlign: "center",
    fontSize: 20,
    paddingBottom: theme.spacing(1),
  },
  marketingSection: {
    padding: "0px 30px 30px 30px",
  },
}));

function templates(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Templates for Social Media automation - Content Generator`}
        description={`Browse our collection of customizable templates designed for marketing success. Choose from professionally designed layouts, customize with your brand elements, and create engaging posts that drive traffic.`}
        url={`https://contentgenerator.io/templates`}
      />
      <Typography variant="h1" className={classes.heading}>
        Customizable Pinterest Post Templates
      </Typography>
      <Typography className={classes.subTitle}>
        Content Generator comes with 100+ Free templates for you to choose from.
      </Typography>
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <div>
            {props.user.authenticated ? (
              <Templates />
            ) : (
              <div className={classes.marketingSection}>
                <LoginOrSignup
                  usePaperBackground={false}
                  titleText={"Login or sign up to see all templates available."}
                />
                <PinterestTemplatesMarketingPage />
              </div>
            )}
          </div>
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, {})(templates);
